import React from 'react';
import { Tab } from 'semantic-ui-react';
import { certificate2, certificate1 } from './';
import { UserActions } from '../../actions';
import { connect } from 'react-redux';
import { history } from '../../helpers';
import { Button, Dimmer, Loader, Segment } from 'semantic-ui-react';
class Certificate extends React.Component {
    constructor(props) {
        super(props);

        let points = {};

        for (let i = 1; i < 21; i++) {
            points[`d${i}`] = 0;
        }
        let certificate = {
            points,
            DriverId: 0,
            Certificate: '',
            VehiclePlate: '',
            VehicleModel: '',
            VehicleBrand: '',
            Distance: 0,
            Company: '',
            VehicleOwner: '',
            DriveCondition: '',
            Traffic: '',
            RoadType: '',
            Weather: '',
            EvaluationDate: 0,
            TotalPoint: 0,
            CompCert: '',
            NofCerts: 0,
        };
        this.state = {
            certificate,
            year: '',
            month: '',
            day: '',
            activeIndex: 0
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.totalInfo = this.totalInfo.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.changeDate = this.changeDate.bind(this);
        this.submitCertificate = this.submitCertificate.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onTabChange = this.onTabChange.bind(this);
        this.recreate = this.recreate.bind(this);
    
    }
    changeDate(event, data) {
        this.setState({
            [data.id]: data.value,
        });
    }
    onSubmit() {
        this.setState({
            activeIndex: 1,
        });

    }
    recreate(){
        window.location.reload();
    }
    submitCertificate(){
        this.state.certificate.DriverId = parseInt(this.props.driverId);
        this.state.certificate.NofCerts = parseInt(this.state.certificate.NofCerts);
        this.state.certificate.Distance = parseInt(this.state.certificate.Distance);
        var datum = new Date( this.state.month+'/'+ this.state.day+'/'+this.state.year);
        this.state.certificate.EvaluationDate = datum.getTime();
        this.props.dispatch(UserActions.create_certificate(this.state.certificate));
    }   

    handleInfo(event, data) {
        this.state.certificate.points[data.id] = parseInt(data.value);
        this.setState({
            certificate: this.state.certificate
        });
    }

    totalInfo() {
        let t = 0;
        let k = 20;
        if(this.props.certificateType === 'Off Road' ){
            k = 15;
        }
        for (let i = 1; i <= k; i++) {
            t = t + this.state.certificate.points[`d${i}`];
        }
        let total = parseInt((100 * t) / (k * 5));
        this.state.certificate.TotalPoint =  total;
        return total;

    }

    handleDropdownChange(event, data) {
        this.setState({
            certificate: { ...this.state.certificate, [data.id]: data.value }

        });
    }
    onTabChange(event, data){
        this.setState({
            activeIndex: data.activeIndex
        });
    }
    handleChange(event) {
        this.setState({
            certificate: { ...this.state.certificate, [event.target.id]: event.target.value }

        });
    }

    render() {
        this.state.certificate.Certificate = this.props.certificateType;
        const panes = [
            {
                menuItem: 'Ozellikler', render: () =>
                    (<Tab.Pane
                        id='Egitimler-ic'
                        attached={false}>
                        {certificate1.bind(this)()}
                    </Tab.Pane>)
            },
            {
                menuItem: 'Degerlendirme', render: () => 
                    <Tab.Pane 
                        id='Egitimler-ic' 
                        attached={false}>
                        {certificate2.bind(this)()}
                    </Tab.Pane>
            }
        ];
        
        return (
            <div>
                {!this.props.cCreated && !this.props.cCreating &&
                <Tab id='Egitimler' ref='Tab1' activeIndex ={this.state.activeIndex} onTabChange={this.onTabChange} panes={panes} menu={{ secondary: true, pointing: true }} />
                }
                {
                    this.props.cCreated &&
                        <Segment id='Egitimler-ic'>
                            <div>Sertifika Olusturuldu
                            <br />
                            <br />
                            <div>
                                <Button onClick={this.recreate} id='Egitimler'>Tekrar Olustur</Button>
                            </div></div>
                        </Segment>
                    
                }
                {this.props.cCreating &&
                    <Segment id='Egitimler-ic'>
                        <Dimmer active inverted style={{ background: 'rgba(255,255,255,0.2)' }}>
                            <Loader inverted />
                        </Dimmer>
                    </Segment>
                } 
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { cCreating, cCreated} = state.createCert;
    return {
        cCreating,
        cCreated
    };
}
const connectedCertificate = connect(mapStateToProps)(Certificate);
export { connectedCertificate as Certificate }; 


// WEBPACK FOOTER //
// ./src/components/PanelPages/Certificate.jsx